import { Alert } from '@wyz/ui';
import clsx from 'clsx';
import * as React from 'react';
import { useLocation } from 'react-router';
import { Footer, NavbarTop, Sidebar } from '~/common/components';
import { Trans, useDebugContext, usePlugin, useTheme } from '~/common/context';

export default function AppLayout(props: React.PropsWithChildren) {
  const { pathname } = useLocation();
  const isDebugMode = useDebugContext();
  const { isFluid, navbarPosition } = useTheme();
  const pluginContext = usePlugin();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className={isFluid ? 'container-fluid' : 'container'}>
      <React.Activity mode={pluginContext.isPluginReady ? 'visible' : 'hidden'}>
        <>
          {pluginContext.enabledPlugins.sidebar ? (
            <custom-sidebar></custom-sidebar>
          ) : (
            <>
              {(navbarPosition === 'vertical' ||
                navbarPosition === 'combo') && <Sidebar />}
            </>
          )}
        </>
      </React.Activity>
      <div className={clsx('main-content')}>
        {isDebugMode && (
          <div className='p-2'>
            <Alert variant='warning' dismissible>
              <Trans i18nKey='app.common.debug_mode.title' />
            </Alert>
          </div>
        )}

        <React.Activity
          mode={pluginContext.isPluginReady ? 'visible' : 'hidden'}
        >
          <>
            {pluginContext.enabledPlugins.navbar ? (
              <custom-navbar name={'App'}></custom-navbar>
            ) : (
              <NavbarTop />
            )}
          </>
        </React.Activity>

        {/*------ Main Routes ------*/}
        {props.children}

        <React.Activity
          mode={pluginContext.isPluginReady ? 'visible' : 'hidden'}
        >
          <>
            {pluginContext.enabledPlugins.footer ? (
              <custom-footer></custom-footer>
            ) : (
              <Footer />
            )}
          </>
        </React.Activity>
      </div>
    </div>
  );
}
